var exports = {
  "Sc": "Checkbox__etfhBh",
  "az": "Box__ZOkPlV",
  "wy": "Box_1___uTmky",
  "pv": "Box_2__41opW8",
  "w9": "Box_3__1gYUdM",
  "pQ": "Box_4__kniium",
  "EY": "Text__vR8-eV",
  "ws": "Box_5__9dub89",
  "UE": "Text_1__412blz",
  "D6": "Box_6___oRL6i",
};

module.exports = exports;
